// load templates
require('./notifications-template.html');

// create ngModule
angular.module('bbl.layout.notifications', [])
  .controller('NotificationsController', ['$scope', '$sce', '$window', 'Auth', '$cookies', Controller]);

function Controller($scope, $sce, $window, Auth, $cookies) {
  var canceled = $cookies.get('canceled-plans');
  $scope.data = {notifications: []};
  var planNotification = {msg: $sce.trustAsHtml('You are approaching your 500 minute trial usage limit. Please choose a plan on <a href="#plans-billing">Plans & Billing</a> to enjoy more awesome conferencing with no limits.')},
      suspendedNotification = {msg: $sce.trustAsHtml('THIS ACCOUNT HAS BEEN SUSPENDED DUE TO AN OVERDUE INVOICE, PLEASE UPDATE YOUR BILLING INFORMATION <a href=#plans-billing>HERE</a>.')},
      cancelationNotification = {msg: $sce.trustAsHtml('You are not currently on a plan. Your number(s) will be deleted in a few days. If you decide to resume service, visit <a href=#plans-billing>plans and billing</a> and choose a plan.'), type: 'warn'};

  Auth.getUserInfo()
    .then(function(user) {
      $scope.user = user;

      var isTrial = +user.plan.trial_period_days > 0,
        isUnlimited = +user.company.minutes_in_package === 0,
        hasEnoughMinutesLeft = +user.company.minutes_left > 100;

      if(isTrial && !hasEnoughMinutesLeft && !isUnlimited) {
        $scope.data.notifications.push(planNotification);
        if($window.Intercom && !$window.localStorage.limitNotificationEventPushed){
          $window.Intercom('trackEvent', 'plan-limit-notice-shown');
          $window.localStorage.limitNotificationEventPushed = true;
        }
      }

      if(user.company.status == 'not-subscribed'){
        $scope.data.notifications.push(canceled ? cancelationNotification : suspendedNotification);
        if($window.Intercom && !$window.localStorage.suspendedNotificationEventPushed){
          $window.Intercom('trackEvent', 'suspended-notice-shown');
          $window.localStorage.suspendedNotificationEventPushed = true;
        }
      }
    })
    .catch(angular.noop);
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/layout/notifications-controller.js
 ** module id = 84
 ** module chunks = 0
 **/